import { ArrowRight, Phone, ShieldCheck, Clock, Star } from "lucide-react";
import { COMPANY } from "@/data/services";

const HERO_IMG =
  "https://images.unsplash.com/photo-1615406020658-6c4b805f1f30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBmYWNhZGV8ZW58MHx8fHwxNzgyNzYwNTAxfDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section id="home" className="relative pt-2 sm:pt-4 lg:pt-6" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center py-16 lg:py-24">
          <div className="animate-fade-up">
            <div className="inline-flex items-center gap-2 bg-blue-50 text-accent text-xs font-semibold px-4 py-2 rounded-full mb-6 uppercase tracking-wide">
              <Star className="h-3.5 w-3.5 fill-accent" /> Commercial Multiservice Contractor
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-extrabold tracking-tighter text-slate-900 leading-[1.05]">
              One Call for{" "}
              <span className="text-accent">Every Trade</span>{" "}
              Your Building Needs.
            </h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl">
              Electrical, plumbing, HVAC, drywall, painting, roofing, buildouts and more —
              installed, maintained and repaired by one trusted crew. {COMPANY.tagline}
            </p>

            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href="#book"
                data-testid="hero-book-cta"
                className="inline-flex items-center gap-2 bg-accent text-white font-semibold px-7 py-4 rounded-md hover:bg-blue-700 transition-colors shadow-sm hover:shadow-md"
              >
                Schedule a Service Call <ArrowRight className="h-5 w-5" />
              </a>
              <a
                href={COMPANY.phoneHref}
                data-testid="hero-phone-cta"
                className="inline-flex items-center gap-2 border border-slate-300 text-slate-900 font-semibold px-7 py-4 rounded-md hover:border-accent hover:text-accent transition-colors"
              >
                <Phone className="h-5 w-5" /> {COMPANY.phoneDisplay}
              </a>
            </div>

            <div className="mt-10 flex flex-wrap gap-x-8 gap-y-3 text-sm text-slate-600">
              <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-accent" /> Licensed & Insured</span>
              <span className="flex items-center gap-2"><Clock className="h-4 w-4 text-accent" /> Fast Response</span>
              <span className="flex items-center gap-2"><Star className="h-4 w-4 text-accent" /> Quality Guaranteed — Lifetime Warranty on Labor</span>
            </div>
          </div>

          <div className="relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
            <div className="relative rounded-2xl overflow-hidden shadow-xl border border-slate-200">
              <img src={HERO_IMG} alt="Commercial building" className="w-full h-[420px] lg:h-[520px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg border border-slate-200 p-5 hidden sm:block">
              <div className="text-3xl font-display font-extrabold text-slate-900">14+</div>
              <div className="text-sm text-slate-500">Trades under one roof</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
